export const PROCEDURETEMPLATES = {
  'Endodontic Treatment': {
    procedureLabel: 'Root canal treatment',
    briefExplanation: 'Root canal treatment',
    intendedBenefits: `- To remove/prevent pain and/or infection\n- To facilitate orthodontic treatment`,
    significantRisks: `- Discovering the tooth is not restorable (e.g. root fracture) and necessitating an extraction
  - Post-operative pain
  - Post-operative swelling
  - Nerve damage leading to temporary or permanent disturbance of sensation e.g. numbness or pain in gum, tongue or lip (remove if not applicable)
  - Missed canal anatomy
  - Canal blockage and failure to gain patency of root terminus
  - Instrument separation
  - Hypochlorite injury
  - Perforations (unwanted openings between tooth and gum)
  - Fracture, chipping or loosening of existing tooth or crown
  - Post-operative infection requiring additional treatment
  - Incomplete healing following completion of treatment
  - The possible need for repeating treatment, with or without endodontic surgery, if the procedure is unsuccessful
  - The possible need for future tooth extraction if the procedure unsuccessful`,
    alternatives: `- No intervention
- Extraction
- Endodontic surgery (if suitable)`
  },
  'Endodontic Microsurgery': {
    procedureLabel: 'Apical surgery/Apicectomy',
    briefExplanation: 'Endodontic surgery or surgical root canal treatment',
    intendedBenefits: `- To remove cystic lesion
- To prevent further episodes of pain and infection
- To seal tooth root to prevent further infection
- To explore or investigate for a potential root fracture`,
    significantRisks: `- Minor oral surgery (lifting flap of gum and removing a small amount of bone)
- Pain, bleeding; swelling; bruising; sutures
- Post operative infection
- Oro-antral communication
- Nerve damage leading to temporary or permanent disturbance of sensation e.g. numbness or pain in gum, tongue or lip
- Damage to adjacent teeth including mobility
- Need for splinting of mobile tooth
- Need for grafting with animal, human cadaver or synthetic bone or tissue replacement materials`,
    alternatives: `- Extraction +/- replacement
- Orthograde endodontic retreatment`
  },
  'Restorability Investigation': {
    procedureLabel: 'Restorability investigation',
    briefExplanation: 'Investigation to check if the tooth can be saved',
    intendedBenefits: `- To investigate if the tooth is saveable, with a view to remove/prevent pain and/or infection via root canal treatment`,
    significantRisks: `- The tooth may be deemed not-restorable or not feasible to restore, necessitating an extraction
- Need for trimming of gum tissue to facilitate decay removal and restoration
- Need for crown lengthening surgery (minor oral surgery involving lifting flap of gum and removing a small amount of bone)
- Pain, bleeding, swelling, bruising
- Post operative infection
- Damage to adjacent teeth`,
    alternatives: `- No intervention
- Extraction`
  },
  'Vital Pulp Therapy': {
    procedureLabel: 'Vital Pulp Therapy',
    briefExplanation: 'Attempt to preserve the vitality of the dental pulp',
    intendedBenefits: `- To remove/prevent pain and/or infection
- To prevent the need for conventional endodontic treatment`,
    significantRisks: `- Discovering the tooth is not restorable (e.g. root fracture) and necessitating an extraction
- Need to proceed to ‘conventional’ or ‘full’ endodontic treatment, either immediately or in near future
- Post-operative pain
- Post-operative swelling
- Hypochlorite injury
- Perforations (unwanted openings between tooth and gum)
- Fracture, chipping or loosening of existing tooth or crown
- Post-operative infection requiring additional treatment
- Incomplete healing following completion of treatment
- The possible need for further treatment if the procedure is unsuccessful (e.g. conventional endodontic treatment)
- The possible need for future tooth extraction if the procedure unsuccessful`,
    alternatives: `- ‘Conventional’ endodontic treatment
- Extraction
- No intervention`
  }
}

export const COMPLEXITY_RISKS_MAP = {
  'tooth position': [
    'Complex anatomy',
    'Restricted access'
  ],
  'root canal shape': [
    'Instrumentation risks (e.g. ledging)',
    'Shaping and disinfection challenges',
    'Obturation difficulties',
    'Pulp stone removal and canal identification'
  ],
  'pulp stones': [
    'Instrumentation risks (e.g. ledging)',
    'Shaping and disinfection challenges',
    'Obturation difficulties',
    'Pulp stone removal and canal identification'
  ],
  'root curvature': [
    'Complex instrumentation',
    'Risk of instrument separation, ledging, perforation, canal transportation'
  ],
  'canal radiographic visibility': [
    'Canal location difficulties',
    'Negotiation challenges',
    'Risk of perforation'
  ],
  'apical morphology': [
    'Irrigant extrusion',
    'Dressing/obturation material extrusion',
    'Apex locator reading difficulties',
    'Achieving satisfactory apical seal'
  ],
  'tooth inclination': [
    'Challenging isolation',
    'Challenging access',
    'Risk of perforation',
    'Risk of missed anatomy'
  ],
  'tooth rotation': [
    'Challenging isolation',
    'Challenging access',
    'Risk of perforation',
    'Risk of missed anatomy'
  ],
  'crown morphology': [
    'Isolation challenges',
    'Access difficulties',
    'Risk of missed anatomy',
    'Technically complex RCT'
  ],
  'pre-treatment': [
    'Isolation challenges',
    'Obtaining coronal seal'
  ],
  'access to root canal system': [
    'Canal orifice location',
    'Risk of perforation'
  ],
  'extra-coronal restoration': [
    'Complex isolation',
    'Dismantling challenges',
    'Risk of iatrogenic damage',
    'Access difficulties',
    'Canal orifice location'
  ],
  'root canal morphology': [
    'Canal identification',
    'Instrumentation of complex anatomy',
    'Obturation of long canals'
  ],
  'previous endodontic treatment': [
    'Negotiating potential pre-operative ledge',
    'Removing RCF material in entirety'
  ],
  'root resorption': [
    'Risk of dressing/obturation material and irrigant extrusion into surrounding structures',
    'Achieving satisfactory obturation',
    'Complex additional management (e.g. surgery)'
  ],
  'iatrogenic incidents': [
    'Risk of perforation with misaligned access',
    'Perforation management and risk of irrigant extrusion',
    'Instrument removal or bypass',
    'Negotiating ledges'
  ],
  'medical history': [
    'Compromised healing response/outcomes',
    'Consequences of failed treatment',
    'Challenging anaesthesia/treatment'
  ],
  'mouth opening': [
    'Access difficulties',
    'Visualisation challenges'
  ],
  'physical limitations': [
    'Access difficulties',
    'Visualisation challenges',
    'Challenging cooperation',
    'Working time constraints'
  ],
  'psychological limitations': [
    'Access difficulties',
    'Visualisation challenges',
    'Challenging cooperation',
    'Working time constraints'
  ],
  'radiographic difficulties': [
    'Diagnostic challenges',
    'Working length determination'
  ],
  'diagnosis': [
    'Challenging diagnosis and treatment planning'
  ],
  'history of trauma': [
    'Challenging diagnosis',
    'Complex management',
    'Potential resorption'
  ],
  'perio-endo lesion': [
    'Challenging diagnosis and treatment planning',
    'Potential surgical intervention',
    'Guarded prognosis'
  ]
}